import { useState } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import { ListItemIcon } from 'shared/mui/List';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { Tooltip } from 'shared/mui/Tooltip';

import { useGetOrderCopyData } from './hooks/useGetOrderCopyData';
import { ListItemTextStyled } from './OrdersListLocalDatagrid.styled';

type Props = {
  timezone: string;
};

export const OrdersListLocalDatagridCopyButton: React.FC<Props> = ({ timezone }) => {
  const translate = useTypedTranslate();

  const { copyData } = useGetOrderCopyData(timezone);
  const { onCloseMenu } = useContextMenuContext();

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipText, setTooltipText] = useState('');

  const handleCopy = async () => {
    const openTooltip = () => {
      setTooltipOpen(true);

      setTimeout(() => {
        setTooltipOpen(false);
        onCloseMenu();
      }, 1000);
    };
    try {
      await navigator.clipboard.writeText(copyData);

      setTooltipText(translate('app.buttons.copied'));
      openTooltip();
    } catch (e: unknown) {
      setTooltipText(translate('app.buttons.copyFailed'));
      openTooltip();
    }
  };

  return (
    <Tooltip disableHoverListener open={tooltipOpen} title={tooltipText}>
      <MenuItem onClick={handleCopy} sx={{ width: '200px' }}>
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemTextStyled primary={translate('app.buttons.copy')} />
      </MenuItem>
    </Tooltip>
  );
};
